module.exports = __webpack_public_path__ + "static/media/thumb.482f7a33.jpg";